/**
 * Generic repeat-card adapter for plain `.cs-item` cards (Tier 4 Phase 3).
 *
 * `.cs-item` is CodeStitch's generic repeated-card class (service cards,
 * pricing tiers, testimonials, steps…). It already gets selected as a
 * `container` editable, but before this adapter, duplicating/deleting/dragging
 * a whole card required precision-clicking card padding. This adapter gives
 * whole-card duplicate/delete/drag from ANY leaf click inside the card.
 *
 * MUST be registered LAST: `resolveAdapter` is first-match-wins, so every
 * specialized family (social-link, nav-link, faq-item, footer-link,
 * button-group-item, card-item/.cs-grid-item, gallery-image) keeps claiming
 * its own probes; this adapter only catches the generic remainder.
 *
 * `reorderAxis:'grid'` uses the 2D nearest-cell hit-testing (multi-row safe)
 * since `.cs-item` containers vary between CSS grid, flex-wrap rows, and
 * flex columns. No postMoveNormalize: ordinal-pinned grids are the
 * `.cs-card-group` family, owned by cardItemAdapter.
 */

import { moveSiblingPreservingEids } from '../element-insert.js';

export const csItemCardAdapter = {
  kind: 'cs-item-card',
  label: 'Card',
  itemSelector: '.cs-item',
  parentSelector: null,
  reorderSelector: '.cs-item',
  reorderSiblingSelector: '.cs-item',
  reorderAxis: 'grid',
  historyLabel: 'Reorder card',
  toastText: 'Card reordered',
  vtPrefix: 'pb-csitem-',
  vtSelector: '.cs-item',
  moveFn: moveSiblingPreservingEids,
  postMoveNormalize: null,
  menuActions: ['duplicate', 'delete'],
  postInsertFlow: null,
  cssPatch: null,
  reorderable: true,

  match(probe) {
    if (!probe || typeof probe.closest !== 'function') return null;
    return probe.closest('.cs-item');
  }
};
